import { mapEnumToOptions } from '@abp/ng.core';

export enum ImageGroupName {
  ImageGroupNamePromo = 0,
  ImageGroupNameFidelityCard = 1,
}

export const imageGroupNameOptions = mapEnumToOptions(ImageGroupName);
